/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NspkProgramResidentObject } from '../models/NspkProgramResidentObject';
import { request as __request } from '../core/request';

export class NspkService {

    /**
     * @returns NspkProgramResidentObject Ok
     * @throws ApiError
     */
    public static async getProgramResidentId(): Promise<NspkProgramResidentObject> {
        const result = await __request({
            method: 'GET',
            path: `/nspk/resident/id`,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}